import hasRole from './hasRole'
import hasPermi from './hasPermi'
import lackRole from "./lackRole";

const install = function(Vue) {
  Vue.directive('hasRole', hasRole)
  Vue.directive('hasPermi', hasPermi)
  Vue.directive('lackRole',lackRole)
}

if (window.Vue) {
  window['hasRole'] = hasRole
  window['hasPermi'] = hasPermi
  Window['lackRole'] = lackRole
  Vue.use(install); // eslint-disable-line
}

export default install
